export const SEARCH_RESULT_PER_PAGE_LIMIT = 30;
